import React from 'react';
import './ODHomeBookEyeTest.scss';
import ButtonOwnDays from '../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';

const ODHomeBookEyeTest = ({ data }) => {
  if (data) {
    return (
      <div className="od-home-bet">
        <div className="od-home-bet__content">
          <div className="od-home-bet__content__left">
            <div className="od-home-bet__content__left__content">
              <h2 className="od-home-bet__content__left__content__title">{data?.title}</h2>
              <div className="od-home-bet__content__left__content__description">
                {data?.description}
              </div>
              <ButtonOwnDays
                fontClass="od-font-reg"
                fontSize="20px"
                mode="oval-grey"
                px="40px"
                py="12px"
                onClick={() =>
                  window.location.assign(data?.button?.link ? data?.button?.link : '/')
                }
              >
                <img
                  alt="book eye test"
                  src="https://static.lenskart.com/media/owndays/desktop/img/od-misc/od-book-eye-test.svg"
                />
                {data?.button?.text}
              </ButtonOwnDays>
            </div>
          </div>
          <div
            className="od-home-bet__content__right"
            style={{ background: `url(${data?.img?.src})` }}
          ></div>
        </div>
      </div>
    );
  }

  return null;
};

export default ODHomeBookEyeTest;
